import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { RemoteObjectSuggestionCountQuery } from '../src/hooks/useFetchSuggestionCount.ts';
import type {
	useFetchSuggestionCountQuery$data,
	useFetchSuggestionCountQuery$variables,
} from '../src/hooks/__generated__/useFetchSuggestionCountQuery.graphql.ts';
import { SearchThirdPartyAuthConfigurationQuery } from '../src/hooks/use3PAuthentication.ts';
import type {
	use3PAuthenticationQuery$data,
	use3PAuthenticationQuery$variables,
} from '../src/hooks/__generated__/use3PAuthenticationQuery.graphql.ts';

export function preloadSuggestionCount(spaceKey: string, cloudId: string): Promise<any> {
	return queryAgg<useFetchSuggestionCountQuery$data, useFetchSuggestionCountQuery$variables>({
		query: RemoteObjectSuggestionCountQuery,
		variables: { cloudId, spaceKey },
	});
}

export function preloadSpaceCurationAuth(cloudId: string): Promise<any> {
	return queryAgg<use3PAuthenticationQuery$data, use3PAuthenticationQuery$variables>({
		query: SearchThirdPartyAuthConfigurationQuery,
		variables: { cloudId },
	});
}
